import React from 'react'
import { Picker } from 'emoji-mart'
import Modal from 'components/Modal'
import { Flex, SUI } from 'shared/ui'
import { isWindows } from 'util/browser'
import themeVars from 'ui_theme/site/globals/site.variables'
import './styles.less'

const selectAdjustment = onSelect => ({ native }) => onSelect(native)

const EmojiPickerModal = ({ bottom = 20, offset, onClose, open, onSelect }) => {
  if (!open) return null

  return (
    <Modal
      styleContainer={{ maxHeight: `calc(100% - ${bottom}px - ${top}px)` }}
      offset={offset}
      onBackgroundClick={onClose}
    >
      <SUI>
        <Flex flexDirection="column">
          <Picker
            autoFocus
            native
            onSelect={selectAdjustment(onSelect)}
            showSkinTones={false}
            showPreview={false}
            color={themeVars.groovy}
            i18n={{ search: 'Search for an emoji...' }}
            // eslint-disable-next-line react/jsx-no-bind
            emojisToShowFilter={emoji => {
              /** (pnagy) In Windows the emojis rendered a bit differently and they totally mess up the view
               * The issue was reported to them and once it's resolved we can remove this filter. Until then we
               * exclude the gender differentiated emojis in Edge
               * https://github.com/missive/emoji-mart/issues/350
               */
              if (!isWindows()) return true
              if (emoji.name === 'Waving White Flag') return true
              if (emoji.name === 'Waving Black Flag') return true
              if (emoji.name === 'Rainbow Flag') return true
              if (emoji.name === 'Triangular Flag on Post') return true
              const isFlagEmoji = emoji.search.indexOf('flag') > -1
              const isDoctorSignInTheString = emoji.unified.indexOf('2695') > -1
              const isLawSignInTheString = emoji.unified.indexOf('2696') > -1
              const isMaleSignInTheString = emoji.unified.indexOf('2642') > -1
              const isFemaleSignInTheString = emoji.unified.indexOf('2640') > -1
              return (
                !isFlagEmoji &&
                !isMaleSignInTheString &&
                !isFemaleSignInTheString &&
                !isDoctorSignInTheString &&
                !isLawSignInTheString
              )
            }}
          />
        </Flex>
      </SUI>
    </Modal>
  )
}

// eslint-disable-next-line react/no-multi-comp
class MountedModal extends React.Component {
  componentDidMount() {
    const { onModalOpen } = this.props
    if (onModalOpen) onModalOpen()
  }

  componentDidUpdate(prevProps) {
    const { onModalOpen, open, reset } = this.props
    if (!prevProps.open && open && onModalOpen) return onModalOpen()
    if (prevProps.open && !open && reset) return reset()
    return null
  }

  runAndClose = fn => (...args) => {
    fn(...args)
    this.props.onClose()
  }

  closeAndRun = fn => (...args) => {
    this.props.onClose()
    return fn(...args)
  }

  render() {
    const { onSelect } = this.props

    return (
      <EmojiPickerModal {...this.props} onSelect={this.runAndClose(onSelect)} />
    )
  }
}

export default MountedModal
